export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-vrtp-new-api.tracwater.online',
  portalId: '676e235b1c32daf3578dec25',
  selectedNode: '6777ba30f7487f745c5a070e'
};
